import { render, staticRenderFns } from "./wappEditar.vue?vue&type=template&id=2fd3324b"
import script from "./wappEditar.vue?vue&type=script&lang=js"
export * from "./wappEditar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports